import React from 'react';
import { Box, IconButton, InputAdornment, MenuItem, Paper, TextField, Tooltip, Typography } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import SearchIcon from '@mui/icons-material/Search';
import { empresasConfig } from '../../sucursalesMercadoLibre/config';

const BarraFiltros = ({
  empresa,
  onEmpresaChange,
  sucursales,
  sucursal,
  onSucursalChange,
  busqueda,
  onBusquedaChange,
  onRefresh,
  loading,
  total,
}) => {
  return (
    <Paper
      variant="outlined"
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: 2,
        p: 2,
        mb: 2,
        borderRadius: 2,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
        <TextField
          select
          size="small"
          label="Empresa"
          value={empresa}
          onChange={(e) => onEmpresaChange(e.target.value)}
          sx={{ minWidth: 160 }}
        >
          {Object.entries(empresasConfig).map(([key, config]) => (
            <MenuItem key={key} value={key}>
              {config.nombre}
            </MenuItem>
          ))}
        </TextField>

        <TextField
          select
          size="small"
          label="Sucursal"
          value={sucursal}
          onChange={(e) => onSucursalChange(e.target.value)}
          sx={{ minWidth: 180 }}
        >
          <MenuItem value="">Todas</MenuItem>
          {sucursales.map((s) => (
            <MenuItem key={s.id} value={s.id}>
              {s.nombre}
            </MenuItem>
          ))}
        </TextField>

        <TextField
          size="small"
          label="Buscar"
          placeholder="Chofer o terminal"
          value={busqueda}
          onChange={(e) => onBusquedaChange(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon fontSize="small" />
              </InputAdornment>
            ),
          }}
        />

        <Typography variant="body2" color="text.secondary">
          {total} chofer{total === 1 ? '' : 'es'}
        </Typography>
      </Box>

      <Tooltip title="Refrescar">
        <span>
          <IconButton onClick={onRefresh} disabled={loading} color="primary">
            <RefreshIcon />
          </IconButton>
        </span>
      </Tooltip>
    </Paper>
  );
};

export default BarraFiltros;
